import { render, staticRenderFns } from "./FileCompare.vue?vue&type=template&id=400d4998&"
import script from "./FileCompare.vue?vue&type=script&lang=js&"
export * from "./FileCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports